var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.985,
    height: 13.8
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".video_svg__a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.9 .9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "video_svg__a",
    d: "M19.18 1.744l-6.1 4.36 6.1 4.36z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "video_svg__a",
    width: 13,
    height: 12,
    rx: 2
  }))));
}
export default __webpack_public_path__ + "static/media/video.38893321.svg";
export { SvgVideo as ReactComponent };